/* unplugin-vue-components disabled */import script from "./RegisteredCapital.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisteredCapital.vue?vue&type=script&setup=true&lang=js"

import "./RegisteredCapital.vue?vue&type=style&index=0&id=854467ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854467ec"]])

export default __exports__